<template>
  <div class="h-64 w-full mx-auto" style="position: relative">
    <chart
      v-if="datacollection"
      ref="bar"
      class="max-w-full h-full"
      :chart-data="datacollection"
      :options="options"
    />
  </div>
</template>

<script>
import Chart from '@/components/Chart.js'
import { mapGetters } from 'vuex'
import { format } from '@/utils.js'
const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
})

export default {
  name: 'TrendChartDashboard',
  components: {
    Chart
  },
  data() {
    return {
      options: {
        defaultFontFamily: 'Degular',
        maintainAspectRatio: false,

        scales: {
          xAxes: [
            {
              ticks: {
                fontFamily: 'Degular'
              },
              gridLines: { display: true }
            }
          ],
          yAxes: [
            {
              id: 'notStacked',
              gridLines: {
                display: true,
                drawTicks: true
              },
              ticks: {
                fontFamily: 'Degular',
                beginAtZero: true,
                callback: function (value) {
                  return usd.format(value / 1000) + 'k'
                }
              },

              afterDataLimits: (axis) => {
                console.log(0, axis)
                let notStacked = axis.chart.scales['notStacked'].max //|| this.max
                let stacked = axis.chart.scales['stacked'].max //|| this.max
                console.log(notStacked, stacked)
                if (notStacked > stacked)
                  axis.chart.scales['stacked'].max = notStacked
                else axis.chart.scales['notStacked'].max = stacked
                console.log(
                  axis.chart.scales['stacked'].max,
                  axis.chart.scales['notStacked'].max
                )
              }
              // afterDataLimits: axis => {
              //   console.log(axis.chart.scales['notStacked'])
              //   let notStacked = axis.chart.scales['notStacked'].max
              //   let stacked = axis.chart.scales['stacked'].max

              //   if (notStacked > stacked) {
              //     axis.chart.scales['notStacked'].max = notStacked || stacked
              //   } else {
              //     axis.chart.scales['notStacked'].max = stacked || notStacked
              //   }
              //   console.log(
              //     0,
              //     notStacked,
              //     stacked,
              //     axis.chart.scales['notStacked'].max
              //   )
              // }
            },
            {
              id: 'stacked',
              stacked: true,
              display: false,
              gridLines: {
                display: true,
                drawTicks: true
              },
              ticks: {
                fontFamily: 'Degular',
                beginAtZero: true,
                callback: function (value) {
                  return usd.format(value / 1000) + 'k'
                }
              },
              afterDataLimits: (axis) => {
                console.log(1, axis)
                let notStacked = axis.chart.scales['notStacked'].max //|| this.max
                let stacked = axis.chart.scales['stacked'].max //|| this.max
                console.log(notStacked, stacked)
                if (notStacked > stacked)
                  axis.chart.scales['stacked'].max = notStacked
                else axis.chart.scales['notStacked'].max = stacked
                console.log(
                  axis.chart.scales['stacked'].max,
                  axis.chart.scales['notStacked'].max
                )
              }
              // afterDataLimits: axis => {
              //   axis.chart.scales['notStacked'].max = this.max

              //   axis.chart.scales['stacked'].max = this.max
              //   console.log(this.max)
              // }
              // afterDataLimits: axis => {
              //   console.dir(axis)
              //   let notStacked = axis.chart.scales['notStacked'].max
              //   let stacked = axis.chart.scales['stacked'].max

              //   if (notStacked > stacked) {
              //     axis.chart.scales['stacked'].max = notStacked || stacked
              //   } else {
              //     axis.chart.scales['stacked'].max = stacked || notStacked
              //   }
              //   console.log(
              //     1,
              //     notStacked,
              //     stacked,
              //     axis.chart.scales['stacked'].max
              //   )
              // }
            }
          ]
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontFamily: 'Degular',
            fontStyle: 'bold',
            fontSize: 16,
            fontColor: '#2C3648'
          }
        },
        tooltips: {
          mode: 'index',
          cornerRadius: 10,
          bodySpacing: 6,
          xPadding: 10,
          yPadding: 10,
          titleAlign: 'center',
          titleFontSize: 14,
          backgroundColor: 'rgba(0,0,0,0.75)',
          titleFontFamily: 'Degular',
          bodyFontFamily: 'Degular',
          bodyFontSize: 13,
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label + ': '
              switch (tooltipItem.datasetIndex) {
                case 0:
                  label += format(tooltipItem.yLabel)
                  break
                case 1:
                  label +=
                    Number(
                      data.datasets[tooltipItem.datasetIndex].secondary[
                        tooltipItem.index
                      ]
                    ) +
                    '% (' +
                    format(tooltipItem.yLabel) +
                    ')'
                  break
                case 2:
                  label +=
                    Number(
                      data.datasets[tooltipItem.datasetIndex].secondary[
                        tooltipItem.index
                      ]
                    ) +
                    '% (' +
                    format(tooltipItem.yLabel) +
                    ')'
                  break
                case 3:
                  label +=
                    Number(
                      data.datasets[tooltipItem.datasetIndex].secondary[
                        tooltipItem.index
                      ]
                    ) +
                    '% (' +
                    format(tooltipItem.yLabel) +
                    ')'
                  break
                case 4:
                  label +=
                    Number(
                      data.datasets[tooltipItem.datasetIndex].secondary[
                        tooltipItem.index
                      ]
                    ) +
                    '% (' +
                    format(tooltipItem.yLabel) +
                    ')'
                  break
              }
              return label
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('storeModule/reports', ['reportsOrderedReverse']),
    max() {
      function getMaxNumberFromArray(array) {
        return array.reduce((a, b) => Math.max(a, b))
      }

      const maxDataPoint = Math.max(
        getMaxNumberFromArray(this.datacollection.datasets[0].data),
        getMaxNumberFromArray(this.datacollection.datasets[1].data),
        getMaxNumberFromArray(this.datacollection.datasets[2].data),
        getMaxNumberFromArray(this.datacollection.datasets[3].data)
      )

      return maxDataPoint
    },
    datacollection() {
      return {
        labels: [
          ...this.reportsOrderedReverse.map((report) =>
            this.$luxon(report.date.seconds, {
              input: 'seconds',
              output: 'MM/dd'
            })
          )
        ],
        datasets: [
          {
            label: 'Total Sales',
            borderColor: 'rgba(255, 99, 132, 1)',
            backgroundColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 3,
            fill: false,
            yAxisID: 'notStacked',
            data: [
              ...this.reportsOrderedReverse.map((report) =>
                Math.abs(report.sales.total)
              )
            ]
          },
          {
            label: 'Prime Costs',
            borderColor: 'rgba(255, 159, 64, 1)',
            backgroundColor: 'rgba(255, 159, 64, 1)',
            borderWidth: 3,
            fill: false,
            yAxisID: 'notStacked',
            data: [
              ...this.reportsOrderedReverse.map((report) =>
                Math.abs(report.primeCost).toFixed(2)
              )
            ],
            secondary: [
              ...this.reportsOrderedReverse.map((report) =>
                (Math.abs(report.primeCostPercent) * 100).toFixed(2)
              )
            ]
          },
          {
            label: 'Labor',
            borderColor: 'rgba(54, 162, 235, 1)',
            backgroundColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            fill: undefined,
            yAxisID: 'stacked',
            data: [
              ...this.reportsOrderedReverse.map((report) =>
                Math.abs(report.payroll.total)
              )
            ],
            secondary: [
              ...this.reportsOrderedReverse.map((report) =>
                (Math.abs(report.payroll.totalPercent) * 100).toFixed(2)
              )
            ]
          },
          {
            label: 'COGS',
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 2,
            fill: undefined,
            yAxisID: 'stacked',
            data: [
              ...this.reportsOrderedReverse.map((report) =>
                Math.abs(report.cogs.total)
              )
            ],
            secondary: [
              ...this.reportsOrderedReverse.map((report) =>
                (Math.abs(report.cogs.totalPercent) * 100).toFixed(2)
              )
            ]
          }
        ]
      }
    }
  },
  // TODO - fix the stacked vs notStacked yAxis label not showing when only stacked data visible
  mounted() {
    // console.log('mounted', this.max)
    console.dir(this.options.scales.yAxes)

    this.options.scales.yAxes[0].afterDataLimits = (axis) => {
      console.log(axis)
      let notStacked = axis.chart.scales['notStacked'].max //|| this.max
      let stacked = axis.chart.scales['stacked'].max //|| this.max
      // // console.log(0, notStacked, stacked)
      if (notStacked > stacked) axis.chart.scales['stacked'].max = notStacked
      else axis.chart.scales['notStacked'].max = stacked

      // axis.chart.scales['notStacked'].max = 35000 //notStacked
      // } else {
      //   axis.chart.scales['notStacked'].max = 35000 // stacked
      // }
      // axis.chart.scales['stacked'].max = 35000
    }

    this.options.scales.yAxes[1].afterDataLimits = (axis) => {
      console.log(axis.chart.scales)
      let notStacked = axis.chart.scales['notStacked'].max //|| this.max
      let stacked = axis.chart.scales['stacked'].max //|| this.max
      // // console.log(1, notStacked, stacked)
      if (notStacked > stacked) axis.chart.scales['stacked'].max = notStacked
      else axis.chart.scales['notStacked'].max = stacked
      // axis.chart.scales['stacked'].max = 35000 // notStacked
      // } else {
      //   axis.chart.scales['stacked'].max = 35000 // stacked
      // }
      // axis.chart.scales['notStacked'].max = 35000
    }
  }
}
</script>
